var boxShadows = {};
export { boxShadows };